import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import CommercialDashboard from './CommercialDashboard'
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";

function commercialDashboardPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
       <MDBox
              sx={{
                display: {
                  xs: "block",
                  sm: "block",
                  md: "none",
                },
              }}
            >
              <AppHeader />
            </MDBox>
      <CommercialDashboard subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default commercialDashboardPage;
